import index from './zh/index'
import chat from './zh/chat'
import employee from './zh/employee'
import news from './zh/news'
import collection from './zh/collection'
import opportunity from './zh/opportunity'
import potentialOrder from './zh/potentialOrder'
import clientPool from './zh/clientPool'
import hotspot from './zh/hotspot'

export default {
  ...chat,
  ...employee,
  ...collection,
  ...opportunity,
  ...news,
  ...potentialOrder,
  ...hotspot,
  ...clientPool,
  rLogin: {
    'systemTip': '系统提示',
    'loginExpired': '登录状态已过期，请重新登录',
    'cancel': '取消',
    'loginAgain': '重新登录'
  },
  language: {
    name: 'zh'
  },
  ...index,
  tip: {
    success: '成功',
    loading: '加载中...'
  },
  live: {
    status: {
      '0': '直播中',
      '1': '待直播',
      '2': '回放'
    },
    startTime: '开播时间',
    looker: '在看',
    toLive: '进入直播'
  },
  Hello: '您好',
  like: '赞',
  exhibitorInfo: '展商详情',
  follow: '关注',
  joinExhibitorNum: '参展次数',
  registeredCapital: '注册资本',
  scaleOfCompany: '公司规模',
  collect: ['收藏', '已收藏'],
  message: '消息',
  'Send message': '发送消息',
  invite: '邀约',
  details: '详情',
  placeholder: '请输入您的',
  pageView: '人浏览',
  collection: '人收藏',
  editor: '编辑',
  companyEditor: '公司信息编辑',
  del: '删除',
  selectType: '请选择类别',
  auditStatus: ['审核通过', '待审核', '未通过审核'],
  upgradeBrowser: '请升级您的浏览器...',
  'Page not found': '页面未找到',

  // Header translation
  logout: '退出登录',
  profile: '个人中心',
  notification: '消息中心',
  myFavorite: '我的收藏',
  watchHistory: '浏览记录',
  customService: '客服中心',
  serviceTel: '客服电话',
  invitation: '邀约管理',
  marketing: '商机管理',
  invitationManagement: "邀约管理",
  moreFeature: '更多功能',
  baseMess: '基本信息',
  companyManage: '公司管理',
  companybaseMessManage: '基本信息管理',
  exhibitsManage: '展品管理',
  actor: '客商',
  exhibitors: '展商',
  exhibits: '展品',
  business: '商机',
  find: '找',
  home: '首页',
  baoiHome: '全国糖酒商品交易会',
  qatitle: 'Q&A',
  disclaimer: '免责声明',
  img: '图片',
  video: '视频',
  address: '地址',
  tel: '电话',
  email: '邮箱',
  www: '网站',
  registerLogin: '欢迎注册/登录',
  passLogin: '使用邮箱登录',
  codeLogin: '使用手机号登录',
  getCode: '获取验证码',
  login: '登录',
  loginRegister: "登录 / 注册",
  register: '新用户注册',
  code: '验证码',
  password: '密码',
  phone: '手机号',
  resetPassword: '设置密码',
  confirm: '确认',
  confirmPassword: '确认密码',
  forgetPassword: '忘记密码?',
  exhibitorCode: '展商确认码',
  backLogin: '返回登录',
  bindExhibitor: '绑定展商',
  setPassPageTip: [
    '我们已给您发送了验证码认邮件，请登录您的邮箱查收验证码，以完成您的密码设置。',
    '设置登录密码以后可使用该密码进行登录'
  ],
  myIndentity: ['我是展商', 'I am exhibitor', '我是客商', 'I am Guest'],
  save: '保存',
  'company name': '公司名称',
  name: '姓名',
  post: '职务',
  country: '国家',
  province: '省份',
  city: '城市',
  ydjTip: '注册功能暂未开放，敬请期待！',
  'You sign up and agree': '登录/注册即同意',
  'Privacy agreement': '《隐私协议》',
  // exhibits form
  'Add Exhibit': '添加展品',
  'Edit Exhibit': '编辑展品',
  'My Exhibit List': '展品列表',
  'Upload picture': '上传照片',
  'Upload picture2': '上传宣传图片',
  'Upload again': '重新上传',
  'Add picture': '添加图片',
  'Only support png & jpg, less than 1Mb': '最佳效果尺寸1200*560像素，png或jpg格式，不超过2M',
  'Only support png & jpg, less than 1Mb 350px': '图片为正方形， 最佳效果尺寸350*350像素，png或jpg格式，不超过2M',
  'uploadTips2': '支持png、jpg格式，不超过2M的竖向长图, 如果图片太长建议切图',
  'Uploaded image only support png and jpg': '上传图片只能是 PNG, JPG 格式!',
  'Uploaded image can not greater than 1Mb': '上传图片不能大于2M',
  'Upload video': '上传视频',
  'Add video': '添加视频',
  'Only support mp4, less than 10Mb': '上传视频不超过100M',
  'Uploaded video only support mp4': '上传视频只能是MP4格式',
  'Uploaded video can not greater than 10Mb': '上传视频不能大于100M',
  'Upload long picture': '上传长图',
  'Add product tags': '添加产品标签',
  'Add form data': '添加数据项',
  'Confirm and publish': '确认发布',
  Yes: '是',
  No: '否',
  'Please fill product name': '请输入产品名称',
  'Please upload at least one picture': '请上传至少一张图片',
  'Please select product tag': '请选择产品标签',
  'Please upload at least one long picture': '请上传至少一张长图',
  'Please select identity': '请选择身份',
  // exhibit detail
  'Exhibitor Name': '所属展商',
  'Exhibit Brand': '展品品牌',
  'Minimum Order Quantity': '可提供最小订货量',
  'Product BuyPrice': '采购价',
  'Product SalePrice': '销售价',
  'Spot Trading': '是否有现货',
  'Product tags': '展品标签',
  'Product Identification': '展品标识',
  'Customization Services': '定制服务',
  'Visible scope': '可见范围',
  'Copy Link': '复制链接',
  'Generate Link': '生成链接',
  Copied: '复制成功',
  'productSearch': '展品名称或货号搜索',
  // company info
  'Upload logo': '上传LOGO',
  'Add company tags': '添加展商标签',
  'Add company description': '添加公司描述',
  'Improve Exhibitor Information': '完善展商信息',
  'comingSoon': '您已注册，请在10月21-27日参观锦汉家居用品及礼品展线上展',
  'setPassWord': '您还未设置密码,现在去设置密码,是否继续?',
  'Reset password successfully': '重置密码成功。',
  'tips':'提示',
  'ok':'确定',
  'cancel':'取消',
  'infoCn': '您目前使用的语言与创建账号时选用的语言不一致，请切换为中文语言来查看信息',
  'infoEn': '您目前使用的语言与创建账号时选用的语言不一致，请切换为英文语言来查看信息',
  'aboutus': '关于我们',
  'comingSoon2': '您的登记信息还没完整，请前往补充填写',
  'auditTip':'您提交的信息正在审核中，请耐心等待，如有问题，请联系info@jinhanfair.com',
  'auditTip1':'抱歉，您提交的信息未通过审核，请重新提交符合要求的证件资料，如有问题，请联系info@jinhanfair.com',
  'resiInfo': '马上预登记',
  'Please enter your code': '请输入您的验证码',
  'change': '换一批',
  'productError': '保存失败：产品类别最多选择三个。',
  'exportCustomer': '导出意向客户',
  'liveName':'请输入直播名称',
  "liveKeyWorld":"关键字搜索",
  'liveStartTime':"请选择开播时间",
  'liveEndTime':"请选择结束时间",
  'liveSponsorName':'请输入展商名称',
  'messageMail': '通知',
  'Message management': '消息列表',
  'mail': {
    'INVITE': '邀约通知',
    'CHECKRESULT': '审核通知',
    'SPONSOR': '主办通知',
    'INTENTIONORDER': '意向订单通知'
  },
  'goBack': '返回上一步',
  'smsCodeLogin': '切换为验证码登录',
  'passwordLogin': '切换为密码登录',
  'registerTips': '请按住滑块,拖动到最右边,进行验证',
  'registerSuccessTips': '验证成功',
  'slideCode':'请滑动验证码',
  'Next': '继续',
  'emailConfirmation': '邮件确认',
  'emailTitle': '请在邮箱中确认您的登录信息',
  'emailContent1': '感谢您创建预登记账户，我们已给您发送了一封确认邮件，请登录您的邮箱查收并点击邮件中的',
  'emailContent2': '确认链接',
  'emailContent3': '，以完成您的预登记注册。',
  'emailContent4': '如您在收件箱中未收到此邮件，可能已被系统拦截，请在垃圾箱中查找。Gmail用户请到广告邮件中查找。',
  // 'emailContent5': '垃圾邮箱',
  // 'emailContent6': '中找回',
  'resendMessage': '重新发送邮件',
  'Service Email': '客服邮箱',
  'infoExistence': '用户已存在',
  'codeRrror': '验证码错误',
  'Create Account': '创建账号',
  'Confirm Email': '邮箱确认',
  'Set Password': '设置密码',
  'Fill in info': '填写信息',
  'Questionnaire': '问卷调查',
  'Completed': '完成注册',
  'Completed Registration': '完成注册',
  'registerCompletedTips': '注册成功',
  'registerSuccessContent': '感谢您注册“全国糖酒商品交易会”。欢迎您前往参观。',
  'registerCompletedTips1': '审核中',
  'registerSuccessContent1': '感谢您注册全国糖酒商品交易会，您提交的信息正在审核中，请耐心等待，如有问题，请联系info@jinhanfair.com。',
  'registerCompletedTips2': '审核不通过',
  'registerSuccessContent2': '我们很抱歉通知您，您提交的全国糖酒商品交易会注册申请未能通过审核，原因是：证件资料不符合要求。请重新提交符合要求的证件资料，我们将为您再次审核。如有问题，请联系info@jinhanfair.com.',
  'goHome': '进入首页',
  'Messag List': '消息列表',
  'baseInfo': '基本信息',
  'Head Image1': '请上传您的证件照，',
  'Head Image2': '该照片将同时用于展会进场证件',
  'workPassTips': '请上传您的个人工作证照片',
  'registrationTips': '请上传您的《外国地区常驻代表机构登记证》照片',
  'Please select the visible range': '请选择可见范围',
  'Please select the visible range2': '请选择产品标签或可见范围',
  'Please select the exhibits to be modified': '请选择要修改的展品',
  'Batch editing': '批量编辑',
  'Batch deletion': '批量删除',
  'Select the current page': '选择当前页',
  'No data on the current page': '当前页面没有数据',
  'a olute or self-relative': '格式不正确',
  'exhformTisp': '注意：',
  'exhformTisp1': '有点击率才能带来转化率',
  'exhformTisp2': '良好的产品展示，能更好的体现卖点，吸引买家点击',
  'exhformTisp3': '核心四图，决定客户是否点击和继续浏览',
  'exhformTisp4': '1.明亮美观,吸引点击',
  'exhformTisp5': '2.展示多颜色、多款式',
  'exhformTisp6': '3.展示优点或者细节',
  'exhformTisp7': '4.说明优惠活动，促进下单',
  'exhformTisp9': '1.此处上传的是单个产品的图片，可上传该产品不同角度，不同款式的图片',
  'exhformTisp10': '2.尺寸不低于750*750像素，支持png、jpg格式，不超过2Mb，您最多可上传十张产品图',
  'exhformTisp11': '提高点击率 主视频先行',
  'exhformTisp12': '相比平面图片，买家更愿意看到生动的视频',
  'exhformTisp13': '产品视频会优先于产品图片被买家看到',
  'exhformTisp14': '视频封面在视频未播放时出现在视频位置',
  'exhformTisp15': '1. 视频封面支持png、jpg格式，不超过1Mb，您可以上传一张封面图',
  'exhformTisp16': '2.视频支持mp4，avi，flv格式，不超过100Mb，您可以上传一个视频',
  'exhformTisp17': '3.视频封面和视频为正方形时，才可获得最佳展示效果',
  'exhformTisp18': '准确选择产品标签，帮助您更精准匹配优质买家',
  'exhformTisp19': '提高转化率 详情要精彩',
  'exhformTisp20': '上传展品详情，突出产品定位和卖点，在众多产品中脱颖而出',
  'exhformTisp21': '用精美的图文讲述故事、介绍产品、描述场景',
  'exhformTisp22': '1.此处上传展品详情图文，为获得最佳显示效果与加载速度，需将图片分段上传',
  'exhformTisp23': '2.建议的每段图片尺寸为1200*600,支持png、jpg格式，不超过1Mb',

  'Cancel the full selection': '取消全选',
  'releaseTips':'您可通过商脉圈发布供应信息，与您选择匹配的目标客户，将通过他/她的商脉圈看到您的发布，为您带来商机。',     
  'hot exhibits': '热门展商',
  'productRangeTip': '全部可见的产品数量最多上传10个，其他范围数量不限',
  'productRangeTip2': ['共', '张,还可以上传', '张'],
  'contactPerson': '您的账号不存在，请联系贵公司管理员创建',
  'noPassword': '此账号未设置密码，请先设置密码，3s自动跳转到设置密码页面',
  'invitationCode': '邀请码',
  'invitationCodeTips1': '1.展商可以将邀请码发送给目标客商',
  'invitationCodeTips2': '2.客商通过邀请码可以查看仅客户池可见的直播与展品',
  'invitationCodeTips3': '3.通过邀请码邀请的客商将会直接加入您的客户池',
  'clickCopy': '点击复制',

  'actorLoginTips': '注意:如账号已创建，首次登录请点"忘记密码"先进行密码设置',
  'note2': '请注意：',
  'noteText': ['最多只能选择 ', ' 个'],
  'Please upload a cover image of the video while uploading the video. Otherwise the front-end display will be blank.': '上传视频的同时请上传一张视频的封面图。否则前端显示会是空白',
  'Please upload Video.': '请上传视频',
  'Watch the live stream.': '观看直播',
  'You need to invite exhibitors, or use the invitation code to watch the live broadcast': '需要邀约展商，或使用邀请码观看直播',
  'To watch the live broadcast, please invite the exhibitor immediately or enter the invitation code to watch.': '观看直播需邀约展商，请',
  'Invite now': '立即邀约',
  'Or, enter the invitation code and watch': '或，输入邀请码后查看',
  'Please enter the invitation code': '请输入邀请码',
  'Contact exhibitors via IM to get the invitation code': '通过IM联系展商获取邀请码', 
  'determine': '确 定',
  'actorDetailRegister': '立即注册可查看更多产品',
  'actorDetailInite': '邀约展商可查看更多产品',
  'actorDetailInite2': '或，输入邀请码后直接查看',
  
  'Invitation code error': '邀请码错误',
  'Password error': '密码错误',
  'Private live broadcasting': '私密直播',
  'inviteTips': '成功邀约展商，可以加入到展商客户池，查看更多经展商授权的展品和直播。',
  'For details, please invite exhibitors': '查看详情需邀约展商，请',
  'Unregistered users can only see limited products. Please register to view more.': '未注册用户仅看到展商全部公开的产品，要查看更多产品，需先完成注册。',
  'inviteTips2': '邀约展商，加入展商客户池，可以在展商展厅里查看到更多产品。',
  'onLine': '本机网络已连接，请刷新您的页面',
  'offLine': '本机网络掉线, 请检查您的网络',
  'error': '错误',
  'The name you entered is inconsistent with the ID number.': '您输入的姓名与身份证号不一致',
  'Token failed to get. Please get again': 'Token获取失败，请重新获取',

  'badgeCard': '卡号',

  'VR Exhibition': 'VR观展',
  'exhibitorManual': '参展商手册',

  'reportPageTip': ['所有浏览数据统计明细包含了游客数据', '导出数据已去除游客数据'],
  'loadingText': '数据获取中...',
  'screenText': '筛 选',
  'Latest Products': '最新产品',
  'Latest Products Tips1': '1.此处上传的是每个产品的封面图片',
  'Latest Products Tips2': '2.尺寸不低于175*175像素，支持png、jpg格式，不超过2Mb，您最多可上传六张产品图',
  'Latest Products Tips3': '3.上传全部六张图片，可实现最佳展示效果',
  'Latest Products Tips4': '此处仅可上传Excel文件',
  'Upload file': '上传文件',
  'Please select at least one exhibit': '请选择至少一个展品',
  'Please enter the information of the invitee': '请输入邀请人信息',
  'downloadTemplate': '下载模板',
  'sendOut': '确认发送',
  'Add': '添加',
  'You can choose up to six exhibits': '最多可以选择六个展品',

  'Modify file name': '修改文件名',

  'This will permanently delete the file. Continue?': '此操作将永久删除该文件, 是否继续?',
  'Delete completed': '删除成功',
  'Please enter a file name': '请输入文件名',
  'filename is incorrect': '文件名不正确',
  'Revise Success': '修改成功',
  'Upload information': '上传资料',
  'Exhibitor information': '展商资料',
  'No valid data': '无有效数据',
  'overseasRegistration': '海外注册',

  'renzheng': '认证用户',
  'renzhengIcon': '认证',
  'VIP': 'VIP 用户',
  'Upload exhibits': '上传展品',
  'APPROVE': '通过',
  'PENDING': '待通过',
  'visitor': '游客',
  'exhibitMaxSort': '当前最大排序值 ',

  'inviteSendTips': '如需批量上传用户邮箱，请下载模板，按照模板填写，上传文件即可',
  'Download Confirmation': '下载确认函',
  'Please wait': '请稍等',
  'hostpotTips': '电子橱窗可帮助您更好地展示产品的组合、搭配，以突显产品的特点与应用场景。',

  'mentInvitation': '邀请函',

  'exhibits-sort-input1': "1、展品排序会按照您输入的序号进行正序，在您当前的展品列表页、客商看您的展商详情页的展品列表中会体现出来；",
  'exhibits-sort-input2': "2、当已有的展品排序序号≥填写序号时，都会+1，例如已有排序1~10，填写了2，那么之前的2变成3，3变成4，以此类推；",
  'exhibits-sort-input3': "3、如果您上传展品未设置序号，那么系统会默认按照您上传的展品时间进行倒叙，且排在已设置序号展品的后面（为了您更好管理您的展品，建议您上传序号）",
  'bannerVideoTip': '每隔5秒自动轮播，请等候',

  'bizhubTips1': '您还没有发布任何采购要求，请点击',
  'bizhubTips2': '发布',
  'Only non Chinese characters can be entered': '只能输入非中文字符',
  'only number': '只能输入数字',

  'Online Sourcing Meeting': '采购配对会',
  'Batch upload of exhibits': '批量上传展品',
  'Download template': '下载模板',
  'Batch upload tips': '批量上传的展品，通过完善展品信息会自动同步到展品管理-展品列表中',
  'Download enterprise QR code': '下载企业二维码', 
  'Please use gift show app to scan code and pay attention to exhibitors': '请使用礼品展App扫码关注展商',
  'Download': '下载证件',
  'Picture clipping': '图片剪裁',
  'clippingTips': '滑动鼠标滚轮放大或缩小图片，进行图片裁剪，以达到最好显示效果',
  'On-site Registration Hours': '证件办理时间：',
  'Fair Opening Time': '展会时间：',
  'copy': '复制',
  'Are you sure copy this item?': '确定复制该展品？',
  'Can be downloaded': '可以下载',
  'prtentialOrderTips': '可以导出意向订单，方便您通过客商的手机号/邮箱/电话进行联系',

  'procurementDocking': '管理采购配对会',
  'ID Card': '身份证',
  'Wrong ID number': '身份证号码错误',
  'Mobile area code cannot be empty': '手机区号不能为空',
  'Company telephone area code cannot be empty': '公司电话区号不能为空',
  'Headquarters telephone area code cannot be empty': '总部电话区号不能为空',
  'Format error': '格式错误',
  'The password length is 6-16 bits': '密码长度为6-16位',

  'RegistrationOfDockingMeeting':'报名采购配对会',
  'ApplicationDockingMeeting':'发布采购需求',
  'Batch upload': '批量上传',

  "INVITE": "邀约客户",
  "CARD": "名片交换",
  "INVITATION":"邀请函",
  "INVITE_CODE": "邀请码",
  "DISTRIBUTION":"管理员分配",
  "NEWCUSTOMER": "创建客户",
  "INVITE_CODE_LIVE": "直播邀请码",
  'ALL': '全部',

  'Filter by source': '按来源筛选',
  '绑定': '绑定',
  '解绑': '解绑',
  '暂未绑定邮箱': '暂未绑定邮箱',
  '暂未绑定手机号': '暂未绑定手机号',
  '更换': '更换',
  '为了保护账户安全，请验证身份': '为了保护账户安全，请用{0}验证身份',
  '至少绑定一个账号': '至少绑定一个账号',
  '请输入账号': '请输入账号',
  '手机号格式错误': '手机号格式错误',
  '邮箱格式错误': '邮箱格式错误',
  '请输入正确的验证码': '请输入正确的验证码',
  '尊敬的': '尊敬的',
  '尊敬的顾客': '尊敬的顾客',
  '邀请函提示内容': '诚邀您参观全国糖酒商品交易会。届时，我司将携多款年度新品重装亮相，期待与您相约洽谈。',
  '谨上': '谨上,',
  '公司名称': '公司名称',
  '提示': '提示:',
  '提示信息': '点击照片或公司名称，完成注册，您将自动添加到此参展商的客户群。',
  '查看更多': '查看更多',
  '晋江热门产业': '晋江热门产业',
  '港澳台和海外侨商': '港澳台和海外侨商',
  '在线会议': '在线会议',

  "该手机号已注册": "该手机号已注册，请去登录",
  "该邮箱已注册": "该邮箱已注册，请去登录",
  "拉取会话失败": "拉取会话失败",

  "发送": "发送",
  "发表情": "发表情",
  "发图片": "发图片",
  "发视频": "发视频",
  "发文件": "发文件",
  "没有更多了": "没有更多了",
  "回到最新位置": "回到最新位置",
  "系统通知": "系统通知",
  "不能发送空消息哦！": "不能发送空消息哦！",
  "由于多实例登录": "由于多实例登录",
  "由于多设备登录": "由于多设备登录",
  "由于 userSig 过期": "由于 userSig 过期",
  "已接入网络": "已接入网络",
  "当前网络不稳定": "当前网络不稳定",
  "当前网络不可用": "当前网络不可用",
  "删除会话": "删除会话",
  "你撤回了一条消息": "你撤回了一条消息",
  "对方撤回了一条消息": "对方撤回了一条消息",
  "撤回了一条消息": "撤回了一条消息",
  "会话": "会话",
  "删除成功": "删除成功",
  "删除失败": "删除失败",
  "刷新列表": "刷新列表",
  "刷新成功": "刷新成功",
  "撤回": "撤回",
  "重新编辑": "重新编辑",
  "已读": "已读",
  "未读": "未读",
  "暂未支持的消息类型": "暂未支持的消息类型",

  "您可以自行解析自定义消息": "您可以自行解析自定义消息",
  "[自定义消息]": "[自定义消息]",
  "单击下载": "单击下载",
  "视频出错，错误原因：": "视频出错，错误原因：",
  
  "游客": "游客",
  "获取游客信息失败": "获取游客信息失败！",
  "获取在线客服信息失败": "获取在线客服信息失败！",
  "已经没有更多的历史消息了哦": "已经没有更多的历史消息了哦",
  'purchaseMeeting': '采购对接会',
  "meetingList": '展商对接会报名',
  


  "零成本": "零成本",
  "定制": "定制",
  "有效": "有效",
  "注册观众才能提交": "注册观众才能提交",
  "对接会描述": "全国糖酒商品交易会采购对接会是全国糖酒商品交易会为采购商与供应商提供的定制化供采对接专享服务。通过视频通话、线下会面、邮件等方式，双方可进行一对一的商贸洽谈，实现更直接、更高效的精准对接，促进双方合作。",
  "对接会提示1": "日程排期",
  "对接会提示2": "点击报名",
  "对接会提示3": "展商展厅",
  "对接会会议按钮": "立即体验优质的虚拟会议",
  "未注册用户仅看到展商全部公开的产品": "立即注册可查看更多的{num}+个产品。",
  "未注册用户仅看到展商全部公开的产品，要查看更多产品，需先完成注册": "未注册用户仅看到展商全部公开的产品，要查看更多产品，需先完成注册",
  "点击查看更多": "点击查看更多",
  "请先登录展商账号": "请先登录展商账号",
  "请进行校验": "请进行校验",
  "登录观众后才能发起需求": "登录观众后才能发起报名",
  "请登出，使用游客身份访问": "请登出，使用游客身份访问",
  "请使用观众身份访问": "请先登录您的观众账号，再进行报名。",
  "请使用展商身份访问": "请使用展商身份访问",
  "图片为": "图片为{resolving}的{type}文件，大小不能超过{size}MB，最多上传{num}张图片",
  "报名状态": "报名状态",
  "没有记录": "没有记录",
  "实名制认证失败": "实名制认证失败",
  "非权益展商": "仅升级套餐或泉州云展套餐展商可报名",
  "公司性质": "公司性质",
  // "公司名称": "公司名称",
  "采购者信息": "采购者信息",
  "联系电话": "联系电话",
  "产品详情": "产品详情",
  "产品标签": "产品类别",
  "产品图片": "产品图片",
  "证书": "产品认证",
  "数量": "采购数量",
  "供应商需求": "对供应商的要求",
  "供应商性质": "供应商性质",
  "公司规模": "企业规模",
  "区域": "区域",
  "其他": "其他要求",
  "预约时间": "预约时间",
  "选择日期": "选择日期",
  "更多": "更多",
  "第场": "第 {num} 场",
  "场次": "场次",
  "立即报名": "立即报名",
  "已经报名": "已经报名",
  "报名结束": "报名结束",
  "全国糖酒商品交易会线上采购对接会报名": "全国糖酒商品交易会线上采购对接会报名",
  "请有意向参加线上采购对接会的参展商填写以下信息": "请有意向参加线上采购对接会的参展商填写以下信息",
  "姓名": "姓名",
  "手机": "手机",
  "网址": "网址",
  "描述": "描述",
  "选择展品": "选择展品",
  "热词搜索": "热词搜索",
  "线下展商": "线下展商",
  "报名成功": "报名成功",
  "采购对接会日程安排": "采购对接会日程安排",
  "序号": "序号",
  "对接会名称": "对接会名称",
  "首页对接会描述": "描述",
  "首页对接会时间": "时间",
  "时间": "时间",
  "地点": "地点",
  "开始时间": "开始时间",
  "结束时间": "结束时间",
  "至": "至",
  "状态": "状态",
  "对接会状态": "对接会状态",
  "已报名": "已报名",
  "未报名": "未报名",
  "已结束": "已结束",
  "未结束": "未结束",
  "展品": "展品",
  "搜索": "搜索"







}